export class FUIIcon {
    public icon: string;
    public height: number;
    public width: number;
    public color: string;

    constructor(icon?: any) {
        this.icon = icon && icon.icon || null;
        this.height = icon && icon.height || null;
        this.width = icon && icon.width || null;
        this.color = icon && icon.color || null;
    }
}
